import Banner from '@ben/orion/banner';

const ReadOnlyBanner = () => {
  return (
    <Banner
      title="Restricted section"
      message="The details in this section cannot be edited in the scheduled version. To make changes, please head to the active version of the benefit using the tabs at the top of the page."
    />
  );
};

export default ReadOnlyBanner;
